export const sendSupportMail = () => {
    window.open('mailto:horienta.support@habacus.com?subject=Supporto per Horienta&body=Ciao Habacus, ');
}